import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
        <div className="descriptionbox-navigator">
            <div className="descriptionbox-nav-box">
                Description
            </div>
            <div className="descriptionbox-nav-box fade">
                Reviews (122)
            </div>
        </div>
        <div className="descriptionbox-description">
            <p>An e-commerce website is an online platform where businesses sell products or services to customers over the internet. These websites typically allow users to browse products, add them to a cart, and securely complete the purchase using various payment methods. E-commerce sites often include features such as product reviews, recommendations, and search functionality to enhance the shopping experience. They also manage inventory, process orders, and handle customer inquiries and support. Overall, e-commerce websites have revolutionized the way people shop, offering convenience, accessibility, and a wide range of products at their fingertips.</p>
            <p>
ChatGPT
E-commerce websites typically display product listings with images, descriptions, and prices to help users find and select items for purchase. They also include shopping cart functionality to allow users to add and manage selected items before proceeding to checkout</p>
        </div>

    </div>
  )
}

export default DescriptionBox